export default urlValue => urlValue ? /http|https/.test(urlValue) ? urlValue : `http://${urlValue}` : null;